import React, { useRef } from "react";
import { Routes, Route } from "react-router-dom";

// All Pages
import Home from "./shared/pages/Home";
import Dashboard from "./shared/pages/Dashboard";
import Billing from "./shared/pages/Billing";
import Documents from "./shared/pages/Documents";
import Payroll from "./shared/pages/Payroll";
import ServiceRequest from "./shared/pages/ServiceRequest";
import Perks from "./shared/pages/Perks";
import LeftNavbar from "./shared/components/LeftNavbar";
import Tasks from "./shared/pages/Tasks";
import Data from "./shared/pages/Data";
import Notifications from "./shared/pages/Notifications";
import CompanyView from "./shared/pages/CompanyView";
import CompanyEmployee from "./shared/pages/CompanyEmployee";
import EmployeeView from "./shared/pages/EmployeeView";
import Notes from "./shared/pages/Notes";
import CompanyList from "./shared/pages/CompanyList";
import Reports from "./shared/pages/Reports";
import Template from "./shared/pages/Template";
import DocumentsDashboard from "./shared/pages/DocumentsDashboard";
import Currency from "./shared/pages/Currency";
import Login from "./shared/pages/Login";
import ResetPassword from "./shared/pages/ResetPassword";
import ResetPasswordRequest from "./shared/pages/ResetPasswordRequest";
import NewCompany from "./shared/pages/NewCompany";
import NewEmployee from "./shared/pages/NewEmployee";

// Homepage Components
import Overview from "./shared/components/Home/Overview";
import SalaryDetails from "./shared/components/Home/SalaryDetails";
import EmploymentContract from "./shared/components/Home/EmploymentContract";
import Insurance from "./shared/components/Home/Insurance";
import Benifits from "./shared/components/Home/Benifits";
import Payslips from "./shared/components/Home/Payslips";

import SupportPopup from "./shared/components/ServiceRequest/SupportPopup";
import { useRootContext } from "./context";
import AddPopup from "./shared/components/AddPopup";
import Intergrations from "./shared/pages/Intergrations";

const App = () => {
  const { state } = useRootContext();
  const LeftNavRef = useRef();
  return state.authenticated ? (
    <div className="text-gray-800 flex justify-between">
      {/* LeftSidebar */}
      {state.authenticated && !state.hiddenLeftbarWhenShowForms && (
        <LeftNavbar LeftNavRef={LeftNavRef} />
      )}
      {state?.showSupportReq && <SupportPopup />}
      {state?.showAddPopup && <AddPopup />}
      <Routes>
        <Route path="/agile-portal" element={<Home LeftNavRef={LeftNavRef} />}>
          <Route path="" element={<Overview />} />
          <Route path="overview" element={<Overview />} />
          <Route path="salary-details" element={<SalaryDetails />} />
          <Route path="employment-contract" element={<EmploymentContract />} />
          <Route path="insurance" element={<Insurance />} />
          <Route path="benifits" element={<Benifits />} />
          <Route path="payslips" element={<Payslips />} />
        </Route>
        <Route path="/" element={<Home LeftNavRef={LeftNavRef} />}>
          <Route path="" element={<Overview />} />
          <Route path="overview" element={<Overview />} />
          <Route path="salary-details" element={<SalaryDetails />} />
          <Route path="employment-contract" element={<EmploymentContract />} />
          <Route path="insurance" element={<Insurance />} />
          <Route path="benifits" element={<Benifits />} />
          <Route path="payslips" element={<Payslips />} />
        </Route>

        <Route path="/new-employee" element={<NewEmployee />} />
        <Route path="/new-company" element={<NewCompany />} />

        <Route
          path="/dashboard"
          element={<Dashboard LeftNavRef={LeftNavRef} />}
        />
        <Route path="/perks" element={<Perks LeftNavRef={LeftNavRef} />} />
        <Route
          path="/intergrations"
          element={<Intergrations LeftNavRef={LeftNavRef} />}
        />

        <Route path="/payroll" element={<Payroll LeftNavRef={LeftNavRef} />} />
        <Route path="/billing" element={<Billing LeftNavRef={LeftNavRef} />} />
        <Route
          path="/documents"
          element={<Documents LeftNavRef={LeftNavRef} />}
        />
        <Route
          path="/service-request"
          element={<ServiceRequest LeftNavRef={LeftNavRef} />}
        />
        <Route path="/tasks" element={<Tasks LeftNavRef={LeftNavRef} />} />
        <Route path="/data" element={<Data LeftNavRef={LeftNavRef} />} />
        <Route
          path="/notifications"
          element={<Notifications LeftNavRef={LeftNavRef} />}
        />
        <Route
          path="/company-view"
          element={<CompanyView LeftNavRef={LeftNavRef} />}
        />

        <Route
          path="/company-employee"
          element={<CompanyEmployee LeftNavRef={LeftNavRef} />}
        />
        <Route
          path="/employee-view"
          element={<EmployeeView LeftNavRef={LeftNavRef} />}
        />
        <Route path="/notes" element={<Notes LeftNavRef={LeftNavRef} />} />
        <Route
          path="/company-list"
          element={<CompanyList LeftNavRef={LeftNavRef} />}
        />
        <Route path="/reports" element={<Reports LeftNavRef={LeftNavRef} />} />
        <Route
          path="/template"
          element={<Template LeftNavRef={LeftNavRef} />}
        />
        <Route
          path="/documents-dashboard"
          element={<DocumentsDashboard LeftNavRef={LeftNavRef} />}
        />

        <Route
          path="/currency"
          element={<Currency LeftNavRef={LeftNavRef} />}
        />
      </Routes>
    </div>
  ) : (
    <Routes>
      <Route path="*" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/reset-password-request"
        element={<ResetPasswordRequest />}
      />
    </Routes>
  );
};

export default App;
